import React, { useEffect, useState } from "react";

const AwardsOne = () => {
	const [awardsData, setAwardsData] = useState(null);

	useEffect(() => {
		// Replacing external API call with local static data
		const localData = {
			title: "Skills & Tech Stack",
			items: [
				{
					title: "Frontend Development",
					year: "React, Next.js, Tailwind CSS",
					award: "HTML5, CSS3, JavaScript",
					link: "#"
				},
				{
					title: "CMS & Platforms",
					year: "Shopify, WordPress, Webflow",
					award: "Wix, Framer",
					link: "#"
				},
				{
					title: "Marketing Tools",
					year: "Google Analytics, SEO, Email",
					award: "Meta Ads, Automation",
					link: "#"
				},
				{
					title: "Version Control & Deployment",
					year: "Git, GitHub",
					award: "Vercel, Netlify, cPanel",
					link: "#"
				}
			]
		};

		setAwardsData(localData);
	}, []);

	return (
		<section className="awards sticky primary-bg">
			<div className="container">
				<div className="row justify-content-between">
					<div className="col-12 col-lg-3">
						{/* Intro */}
						<div className="intro">
							<h3 className="title">
								{awardsData ? awardsData.title : "Loading..."}
							</h3>
						</div>
					</div>

					<div className="col-12 col-lg-8">
						<ul className="list-group list-group-flush">
							{awardsData && awardsData.items.length > 0 ? (
								awardsData.items.map((award, index) => (
									<li key={index} className="list-group-item">
										<div className="content">
											<h4 className="title mt-0 mb-3">{award.title}</h4>
											<span className="tags mt-3 mt-md-0">
												{award.year} - {award.award}
											</span>
										</div>
										{/* Award Button */}
										<a className="award-btn rounded-pill" href={award.link}>
											<i className="icon rotate bi bi-arrow-right-short m-0"></i>
										</a>
									</li>
								))
							) : (
								<li className="list-group-item">
									<div className="content">Loading skills...</div>
								</li>
							)}
						</ul>
					</div>
				</div>
			</div>
		</section>
	);
};

export default AwardsOne;
